export default __webpack_public_path__ + "static/media/product_cashback.510ab9d5.svg";